import { render, staticRenderFns } from "./BoxHeader.vue?vue&type=template&id=3d7896aa&scoped=true&"
import script from "./BoxHeader.vue?vue&type=script&lang=ts&"
export * from "./BoxHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BoxHeader.vue?vue&type=style&index=0&id=3d7896aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7896aa",
  null
  
)

export default component.exports